<template>
  <div>
    <v-form :model="valid" ref="formReport" lazy-validation>
      <v-card
        class="mx-auto"
        outlined
      >
        <v-card-title>
          <v-row>

            <v-col class="d-flex" cols="12" md="4" sm="4">
              <v-autocomplete
                :disabled="! isOperator"
                outlined
                dense
                v-model="params.member_id"
                :items="listMemberProduct"
                item-text="full_name"
                item-value="contact_id"
                :label="$t('shopOwner')"
                :placeholder="$t('all')"
                clearable
                :rules="selectRules"
                required
              >
                <template v-slot:selection="{ item }">{{ item.full_name }}</template>
                <template v-slot:item="{ item }">{{ item.full_name }}</template>
              </v-autocomplete>
            </v-col>

            <v-col class="d-flex" cols="12" md="4" sm="4">
              <v-autocomplete
                outlined
                dense
                v-model="params.category_id"
                :items="categoryOptionList"
                item-text="text"
                item-value="id"
                :label="$t('category')"
                :placeholder="$t('all')"
                clearable
                required
              >
                <template v-slot:selection="{ item }">{{ item.text }}</template>
                <template v-slot:item="{ item }">{{ item.text }}</template>
              </v-autocomplete>
            </v-col>

            <v-col class="d-flex" cols="12" md="4" sm="4">
              <v-autocomplete
                outlined
                dense
                v-model="params.product_id"
                :items="listProductOutsideEco"
                auto-select-first
                item-text="name"
                item-value="variation_id"
                :label="$t('product')"
                :placeholder="$t('all')"
                clearable
                required
              >
                <template v-slot:selection="{ item }">{{ item.name }}</template>
                <template v-slot:item="{ item }">{{ item.name }}</template>
              </v-autocomplete>
            </v-col>

          </v-row>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            style="min-width: 150px"
            class="success"
            @click="handleRun('nowebview')"
            :loading="loadingReport"
            :disabled="loadingReport"
          >
            <font-awesome-icon icon="step-forward"/>
            <span style="padding-left: 10px">{{ $t('check') }}</span>
            <template v-slot:loadingReport>

        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <div id="section-to-print">
      <v-row type="flex" class="row-bg" justify="center">
        <h3>{{ $t("stockReconcile") }}</h3>
        <v-col style="padding: 0px !important;" cols="12" md="12" sm="12"></v-col>

        <v-col sm="6" md="6" lg="6" xs="12" :cols="$vuetify.breakpoint.mobile? '12' : '6'" style="text-align: left">
          {{ $t('date') }} ៖ {{ params.date }}
        </v-col>
        <v-col sm="6" md="6" lg="6" xs="12" :cols="$vuetify.breakpoint.mobile? '12' : '6'" v-if="token==='nowebview'"
               :style="$vuetify.breakpoint.mobile ? 'padding-top: 0px !important;' :''">
          {{ $t('member') }} ៖ {{ memberName || $t('all') }}
        </v-col>
        <v-col style="padding: 0px !important;" cols="6" md="6" sm="6"></v-col>
        <v-col cols="12" style="overflow-x: auto;display: block;white-space: nowrap;">
          <table class="report">
            <thead>
            <tr>
              <th>{{ $t("n0") }}</th>
              <th>{{ $t("item") }}</th>
              <th>{{ $t("qty") }}</th>
              <th style="text-align: right">{{ $t("stockOnHand") }}</th>
              <th style="text-align: right">{{ $t("status") }}</th>
              <th style="text-align: right">{{ $t("note") }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(doc,j) in dataList" :key="j">
              <td style="text-align: center">{{ j + 1 }}</td>
              <td>{{ doc.sku }} : {{ doc.product_name }}</td>
              <td style="text-align: center">{{ doc.qty_on_hand | formatNumber }} {{ doc.unit_name }}</td>

              <td style="text-align: right">
                <v-text-field
                    style="min-width: 150px"
                    type="number"
                    v-model="doc.change_qty"
                    hide-details="auto"
                    min="0"
                    dense
                    @change.native="updateStockDetail(doc,j)"
                    @keyup.native="updateStockDetail(doc,j)"
                >
                </v-text-field>
              </td>

              <td style="text-align: right">
                <v-select
                  v-model="doc.status"
                  :items="[{value: 'sub', label: 'substraction'}, {value: 'add', label: 'addition'}]"
                  item-name="label"
                  item-value="value"
                  @change.native="updateStockDetail(doc,j)"
                >
                <template v-slot:item="{item}">{{$t(item.label)}}</template>
                <template v-slot:selection="{item}">{{$t(item.label)}}</template>
                </v-select >
              </td>

              <td style="text-align: right">
                <v-text-field
                    style="min-width: 150px"
                    v-model="doc.note"
                    hide-details="auto"
                    dense
                    @change.native="updateStockDetail(doc,j)"
                    @keyup.native="updateStockDetail(doc,j)"
                >
                </v-text-field>

              </td>
            </tr>
            </tbody>

          </table>
          <v-row style="padding-top: 20px">
            <v-spacer></v-spacer>
            
            <v-btn
              v-if="! isOperator"
                rounded
                @click="handleUpdateStock($event)"
                style="min-width: 150px"
                color="success"
                :loading="loadingSubmit"
                :disabled="loadingSubmit"
            >
              <font-awesome-icon icon="check-circle" style="margin-right: 10px"/>
              {{ $t('update') }}

              <template v-slot:loadingSubmit>
                <span class="custom-loader">
                <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
            
          </v-row>
        </v-col>
      </v-row>

    </div>


  </div>

</template>

<script>
import ValidatorMixin from "../../../mixins/validatorMixin";
import OptionDataMixin from "../../../mixins/optionDataMixin";
import ReportDataMixin from "../../../mixins/reportDataMixin";
import moment from "moment";
import {provider} from "../../../service/provider"
import axios from "axios";

export default {
  components: {},
  mixins: [ValidatorMixin, OptionDataMixin, ReportDataMixin],
  data() {
    return {
      valid: false,
      loadingReport: false,
      loadingSubmit: false,
      searchClient: "",
      params: {
        id: "",
        member_id: '',
        category_id: "",
        product_id: "",
        note: " ",
        date: moment().format("YYYY/MM/DD"),
        eco_business: "out_side",
        offset: 0,
        limit: 10000
      },
      dataList: [],
      vendorData: [],
      memberName: "",
      token: ""
    }
  },
  methods: {
    handlePrint(event) {
      event.preventDefault();
      window.print();
    },
    handleUpdateStock(e) {
      e.preventDefault();
      let vm = this;
      if (vm.$refs.formReport.validate()) {
        vm.loadingSubmit = true;
        let newData = {};
        newData.id = "";
        newData.client_id = vm.params.member_id;
        newData.date = vm.params.date;
        newData.note = vm.params.note;
        newData.eco_business = "out_side";
        newData.transaction_reconcile_line=[];
        vm.dataList.map((o) => {
          if (o.change_qty !== "") {
            newData.transaction_reconcile_line.unshift(o);
          }
        });
        let url = provider.baseURL + provider.storeStockReconcile;
        return new Promise((resolve, reject) => {
          if (vm.dataList.length > 0) {
            axios.post(url, newData, {headers: {Authorization: localStorage.token}}).then(
                res => {
                  if (res.data.response && res.data.response.code === 200) {
                    resolve(res.data.data);
                    vm.loadingSubmit = false;
                    vm.dataList = [];
                    vm.$notify({
                      title: "Success",
                      message: vm.$t("success"),
                      type: "success",
                      duration: 700
                    });
                  } else {
                    vm.loadingSubmit = false;
                  }
                },
                error => {
                  reject(error);
                }
            );
          } else {
            vm.$notify({
              title: "Warning",
              message: vm.$t("failed"),
              type: "warning",
              duration: 700
            });
            vm.loadingSubmit = false;

          }
        });

      }

    },
    updateStockDetail(doc, j) {
      let vm = this;
      let newDoc = doc;
      vm.dataList[j] = newDoc;
    },
    
    handleRun(token) {
      let vm = this;
      if (vm.$refs.formReport.validate()) {
        vm.loadingReport = true;
        let url = provider.baseURL + provider.getListStockClientById;

        return new Promise((resolve, reject) => {
          axios.post(url, vm.params, {headers: {Authorization: token === "nowebview" ? localStorage.token : token}}).then(
              res => {
                if (res.data.response && res.data.response.code === 200) {
                  resolve(res.data.data);
                  vm.loadingReport = false;
                  res.data.data.map((d) => {
                    d.product_id = d.id;
                    d.transaction_reconcile_line_id = "";
                    d.qty_on_hand = d.qty;
                    d.change_qty = "";
                    d.status = 'add'
                    d.note = "";
                    return d;
                  })
                  vm.dataList = res.data.data;
                } else {
                  vm.loadingReport = false;
                }
              },
              error => {
                reject(error);
              }
          );
        });

      }
    },

    fetchProductOpt(val) {
      let vm = this;
      vm.fetchProduct(val, vm.params.category_id, "", "", "", "");
    }
  },
  watch: {
    "params.member_id"(member_id){
      this.fetchCategoryOption(member_id, '');
    },
    "params.category_id"(val) {
        let vm = this;
        if(val){
          vm.fetchListProdctOutsideEco({
            category_id: val,
            contact_id: this.$store.state.userDoc.contact_id,
            currency_code: '',
            client_type: '',
            type: '',
            limit: vm.noLimit,
            offset: vm.currentPage,
            search: ''
          });
        }
      },
  },
  created() {
    if(! this.isOperator){
      this.params.member_id = this.$store.state.userDoc.contact_id;
    }
    this.fetchMemberProduct();
  }
}
</script>